import React from "react";
import { BibleVerse } from "../lib/types";

interface Skeleton {
  type: "loading";
}

interface Data {
  // loading?: boolean;
  type: "data";
  verse: BibleVerse;
}

type BibleVerseItemProps = Skeleton | Data;

export default function BibleVerseItem(props: BibleVerseItemProps) {
  if (props.type === "loading") {
    return (
      <div className="w-full p-3 text-white bg-gray-300 rounded-xl animate-pulse">
        <p className="w-2/3 h-4 text-2xl bg-gray-400 rounded-lg" />

        <div className="mt-4">
          <p className="h-2 mt-0 bg-gray-400 rounded-md" />
          <p className="h-2 mt-2 bg-gray-400 rounded-md" />
          <p className="h-2 mt-2 bg-gray-400 rounded-md" />
          <p className="h-2 mt-2 bg-gray-400 rounded-md" />
          <p className="h-2 mt-2 bg-gray-400 rounded-md" />
        </div>

        <p className="w-1/2 h-3 mt-4 bg-gray-400 rounded-md" />

        <p className="flex items-center mt-5 space-x-4">
          <span className="flex-1 h-3 bg-gray-400 rounded-md " />
          <span className="flex-1 h-3 bg-gray-400 rounded-md " />
        </p>
      </div>
    );
  }

  return (
    <div className="w-full p-3 text-white bg-gray-900 rounded-xl">
      <p className="text-xl font-bold text-cente">Verse of the Day</p>
      <p className="mt-3 text-sm font-semibold leading-snug">{props?.verse?.text}</p>

      <p className="mt-4 text-sm text-orange">
        {props?.verse?.version} {props?.verse?.reference}
      </p>

      <p className="flex items-center justify-end mt-4 space-x-4">
        {/* <button className="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-orange"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>

          <p className="px-2 text-sm">Like</p>
        </button>

        <button className="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-orange"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <p className="px-2 text-sm">Add. To Favorites</p>
        </button> */}
      </p>
    </div>
  );
}
